export const getDataFromViaCep = async (cep) => {
  const response = await fetch(`https://viacep.com.br/ws/${cep}/json/`, { method: 'GET' })
  const data = await response.json()

  if (data.erro) {
    throw Error('CEP não encontrado')
  }
  return data
}
